import React from 'react';
import { MdAddCircle } from 'react-icons/md';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import { Grid } from '~/components';
import { useForm } from '~/hooks';
import { useSectionDetail } from '~/hooks/useSection';
import sectionTypes from '../sectionTypes';
import DeedOfTrustForm from './DeedOfTrustForm';
import { AiOutlineSearch } from 'react-icons/ai';

const initialState = {
    sectionId: 0,
    sectionDetails: [],
    selectedDeed: {},
    modalOpen: false,
    editDeed: false
};

const DeedsOfTrust = (props) => {

    const {
        titleOpinionId,
        readonly = false,
        sectionId,
        sectionDetails
    } = props;

    const {   
        saveDetail, 
        deleteDetail 
    } = useSectionDetail(sectionTypes.DEED, sectionId, titleOpinionId);
    
    const { state, fieldActions } = useForm({ initialState });

    const openModal = () => fieldActions.onChange(true, 'modalOpen');

    const closeModal = async () => {
        await fieldActions.onChange({}, 'selectedDeed');
        await fieldActions.onChange(false, 'modalOpen');
    };

    const saveDeed = async (values) => {
        const {
            mortgators,
            beneficiary,
            trustee,
            securingAmountOf,
            purchasePrice,
            dated,
            recordedOn,
            book,
            page,
            countyRegistry,
            reRecordedOn,
            reBook,
            rePage,
            reCountyRegistry,
            assignedTo,
            assignedBook,
            assignedPage,
            assignedCountyRegistry,
            lienOrder,
            copyOfDeed
        } = values;

        const data = {
            sectionId,
            mortgators,
            beneficiary,
            trustee,
            securingAmountOf,
            purchasePrice,
            dated,
            recordedOn,
            book,
            page,
            countyRegistry,
            reRecordedOn,
            reBook,
            rePage,
            reCountyRegistry,
            assignedTo,
            assignedBook,
            assignedPage,
            assignedCountyRegistry,
            lienOrder: lienOrder,
            documents: copyOfDeed
        };

        await saveDetail(data, values.sectionDetailId);
        closeModal();
    };

    const editDeed = async (data) => {
        await fieldActions.onChange(data, 'selectedDeed');
        await fieldActions.onChange(true, 'editDeed');
        openModal();
    };

    const addDeed = async () => {
        await fieldActions.onChange(false, 'editDeed');
        openModal();
    };

    const deleteDeed = id => deleteDetail(id);

    return (
        <>
            <Deeds className='mt-8' details={sectionDetails} onEdit={editDeed} onDelete={deleteDeed} readonly={readonly}/>
            { !readonly && (
                <div className='mt-4 flex items-center'>
                    <button
                        className='rounded-full py-2 px-4 bg-primary-50 text-white text-sm font-medium focus:outline-none hover:bg-primary-60 flex items-center justify-between'
                        onClick={addDeed}
                    >
                        <MdAddCircle className='mr-2' size='1.25em'/>
                        Add Another
                    </button>
                </div>
            )}
            <DeedOfTrustForm
                isOpen={state.values.modalOpen}
                closeModal={closeModal}
                saveDeed={saveDeed}
                readonly={readonly}
                deed={state.values.selectedDeed}
                edit={state.values.editDeed}
            />
        </>
    );
};

export default DeedsOfTrust;

const headerClassName = 'bg-gray-50 py-2 px-4 border-b text-left';
const props = {
    className: 'py-1 px-4 border-t text-xs text-neutral-70'
};

function Deeds({ details, className, onEdit, readonly = false, onDelete }) {
    const columns = [
        {
            title: 'Deed(s) Of Trust',
            cell: ({ data }) => {
                return (
                    <>{`Deed of Trust #${data.index + 1}`}</>
                );
            },
            canSort: false,
            headerClassName,
            props
        },
        {
            headerClassName,
            props,
            key: 'actions',
            canSort: false,
            title: '',
            cell: ({ data }) => {

                return readonly 
                    ? (
                        <span className="flex justify-end h-8">
                            <button className="focus:outline-none" onClick={() => onEdit(data)}>
                                <AiOutlineSearch />
                            </button>
                        </span>
                    ) : 
                    (
                        <span className="flex justify-end h-8">
                            <button className="mr-5 focus:outline-none"
                                onClick={() => onEdit(data)}
                            >
                                <FaPencilAlt />
                            </button>
                            <button className="focus:outline-none"
                                onClick={() => onDelete(data.sectionDetailId)}>
                                <FaTrash />
                            </button>
                        </span>
                    );
            }
        }
    ];

    const deeds = Array.isArray(details)
        ? details.map((d,i) => ({ ...d, index: i }) )
        : [];

    return (
        <Grid className={className} columns={columns} data={deeds}/>
    );
}